/**
 *
 * This file is NOT generated yet, but it should be generated
 *
 * Add all kinds of types that we should actually generate instead of defining by ourselves
 * like graphql types or openapi spec types
 */

export interface OrganizationMember {
  user_id: string;
  role_name: string;
  picture: string;
  name: string;
  email: string;
  created: string;
}

export type PaginatedList<T extends Record<string, unknown>> = {
  start: number;
  limit: number;
  length: number;
  total: number;
  next: string;
} & T;

export interface ProjectKey {
  projectId: string;
  organizationId: string;
  encKey: string;
}

export interface ProjectMember {
  accountId: string;
  projectId: string;
  publicKey: string;
}

export interface MemberProjectKey {
  accountId: string;
  projectId: string;
  encSymmetricKey: string;
}

export interface ResponseGetMyProjectKeys {
  projectKeys: ProjectKey[];
  members: ProjectMember[];
}

export interface ResponseGetAllMyProjectKeys {
  projectKeys: ProjectKey[];
}

export interface Whoami {
  sessionAge: number;
  accountId: string;
  email: string;
  firstName: string;
  lastName: string;
  created: number;
  isPaymentRequired: boolean;
  isTrialing: boolean;
  isVerified: boolean;
  isAdmin: boolean;
  trialEnd: string;
  planName: string;
  planId: string;
  canManageTeams: boolean;
  maxTeamMembers: number;
  passwordSet: boolean;
  canUnsetPassword: boolean;
  unsubscribedFromEmails: boolean;
  customerId: string;
  subscriptionId: string;
}

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
  isExternallyProvisioned: boolean;
  encryptionEnabled: boolean;
  createdAt: string;
}

export interface CurrentUserEncryptionKeys {
  saltEnc: string;
  encDriverKey: string;
  encPrivateKey: string;
  encSymmetricKey: string;
}

export interface GroupMemberInstruction {
  accountId: string;
  email: string;
  publicKey: string;
}

export interface GroupInviteKey {
  projectId: string;
  organizationId: string;
  encKey: string;
}
export interface GroupInstruction {
  encryptionRequired: boolean;
  members: GroupMemberInstruction[];
  keys: GroupInviteKey[];
}

export interface GroupMemberKey {
  accountId: string;
  organizationId: string;
  projectId: string;
  encKey: string;
}

export interface GroupMember {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
  roleName: string;
}

interface TeamMember {
  id: string;
  picture: string;
  email: string;
}

export interface Team {
  id: string;
  name: string;
  picture: string;
  description: string;
  isOnlyScim: boolean;
  members: TeamMember[];
  totalMembers: number;
  canDelete: boolean;
}

export interface TeamScimLink {
  id: string;
  name: string;
  isReadOnly: boolean;
}

export interface TeamOrgLink {
  id: string;
  name: string;
}

export interface TeamDetail {
  id: string;
  name: string;
  picture: string;
  description: string;
  isOnlyScim: boolean;
  scimGroups: TeamScimLink[];
  orgLinks: TeamOrgLink[];
}

export interface EnterpriseMember {
  accountId: string;
  email: string;
  name: string;
  roleId: string;
  roleName: string;
  picture: string;
  loggedInAt?: string;
  isScimLinked?: boolean;
  scimAssignedAt?: string;
  e2eeEnabled?: boolean;
  canDelete?: boolean;
  actions30d?: number;
  isPending?: boolean;
}

export enum EnterpriseRoleEnum {
  Owner = 'owner',
  CoOwner = 'co-owner',
  Billing = 'billing-only',
  Member = 'member',
  OwnAccount = 'your own account',
}
